import React from 'react'
import { usePutRequest } from '../hooks/request'
import { useMessage } from '../hooks/message'
import DocumentsProductForm from './DocumentsProductForm'

export default function DocumentsProductUpdate({ onCancel, item, refresh, arrayHelp }) {
    const [showMessage] = useMessage()
    const update = usePutRequest({ url: `/product/document-product/${item.id}` })

    async function onSubmit(data) {
        const { success, error, response } = await update.request({
            data,
        })

        if (success) {
            refresh()

            // Check if a new product was created (has 'message' field) or existing product updated
            if (response?.message) {
                // New product was created due to name change
                showMessage('Новый товар создан (из-за изменения названия)', 'is-success')

                if (arrayHelp) {
                    const localItems = JSON.parse(localStorage.getItem('items')) || []

                    // For new product creation, use the new product ID and preserve form data
                    const updatedProduct = {
                        ...localItems[arrayHelp.index], // Keep existing form data (prices, quantities)
                        ...response, // Override with new product data from backend
                        id: response?.id || response?.pk, // Ensure we have the new product ID
                        name: response?.name || data.name, // Use the new name
                        message: undefined, // Remove message field for table display
                        // Preserve form-specific fields that might not come from backend
                        quantity: localItems[arrayHelp.index]?.quantity || 1,
                        // Map backend field names to frontend format
                        paymentType: response?.payment_type || response?.paymentType || localItems[arrayHelp.index]?.paymentType,
                    }

                    // Update localStorage
                    localItems[arrayHelp.index] = updatedProduct
                    localStorage.setItem('items', JSON.stringify(localItems))

                    // Update form array with complete product data
                    arrayHelp.arrayHelpers.replace(arrayHelp.index, updatedProduct)
                }
            } else {
                // Existing product was updated
                showMessage('Товар успешно обновлен', 'is-success')

                if (arrayHelp) {
                    const localItems = JSON.parse(localStorage.getItem('items')) || []

                    const updatedProduct = {
                        ...localItems[arrayHelp.index], // Keep existing form data
                        ...response, // Apply backend updates
                        // Map backend fields to frontend naming
                        paymentType: response?.payment_type || response?.paymentType || localItems[arrayHelp.index]?.paymentType,
                        // Preserve form-specific fields
                        quantity: localItems[arrayHelp.index]?.quantity || '',
                    }

                    localItems[arrayHelp.index] = updatedProduct
                    localStorage.setItem('items', JSON.stringify(localItems))
                    arrayHelp.arrayHelpers.replace(arrayHelp.index, updatedProduct)
                }
            }

            onCancel()
        }
        if (error) {
            showMessage(error?.data?.detail || 'Произошла ошибка', 'is-danger')
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Изменить товар</b>
            </h1>

            <DocumentsProductForm onCancel={onCancel} onSubmit={onSubmit} loading={update.loading} initialValues={item} />
        </div>
    )
}
